const LOG_KEY = "__AUTH_DBG__";

declare global {
  interface Window {
    __AUTH_DBG__?: string[];
  }
}

export function authDbg(...args: unknown[]) {
  const ts = new Date().toISOString().slice(11, 23);
  const msg = `[AUTH_DBG ${ts}] ${args.map((a) => (typeof a === "string" ? a : JSON.stringify(a))).join(" ")}`;

  if (typeof window !== "undefined") {
    const buf = window.__AUTH_DBG__ ?? [];
    buf.push(msg);
    if (buf.length > 500) buf.splice(0, buf.length - 500);
    window.__AUTH_DBG__ = buf;
  }

  if (import.meta.env.DEV) {
    console.log(msg);
  }
}

export function printAuthDbg() {
  const buf = typeof window !== "undefined" ? window.__AUTH_DBG__ : undefined;
  if (buf && buf.length > 0) {
    console.log("=== AUTH DEBUG LOGS ===");
    buf.forEach((l) => console.log(l));
    console.log("=== END AUTH DEBUG LOGS ===");
  } else {
    console.log(
      "No auth debug logs found. Type printAuthDbg() again after triggering the issue.",
    );
  }
}
